import { useRef } from 'react';

import {
    Button,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
} from '@chakra-ui/react';

import Const from '../Constants';

// Shared confirmation dialog for destructive delete actions. Owns the cancel
// ref and the app's standard styling; callers drive it with useDisclosure and
// pass an onConfirm handler.
const ConfirmDeleteDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = 'Delete',
    body = "Are you sure? This can't be undone.",
    confirmLabel = 'Delete',
    cancelLabel = 'Cancel',
}) => {
    const cancelRef = useRef();

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
        >
            <AlertDialogOverlay
                bg={'rgba(0, 0, 0, 0.6)'}
            >
            <AlertDialogContent
                bg={Const.Gray31}
                color={Const.White}
            >
                <AlertDialogHeader fontSize={Const.LG}>
                    {title}
                </AlertDialogHeader>

                <AlertDialogBody>
                    {body}
                </AlertDialogBody>

                <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onClose} size={Const.SM}>
                    {cancelLabel}
                </Button>
                <Button colorScheme={'red'} onClick={onConfirm} ml={3} size={Const.SM}>
                    {confirmLabel}
                </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};

export default ConfirmDeleteDialog;
